import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useMetaAdAccountStore = defineStore('metaAdAccountStore', {
  id: 'metaAdAccountStore',
  state: () => ({
    loading: false,
    error: null,
  }),
  getters: {},
  actions: {
    async getFacebookAdAccounts(filters = {}) {
      const {data} = await axios.get('facebook/ad-accounts', {params: filters})

      return data
    },

    async getFacebookAdAccount(externalId, filters = {}) {
      const {data} = await axios.get(`facebook/ad-accounts/${externalId}`, {params: filters})

      return data
    },

    async updateFacebookAdAccount(id, payload) {
      this.error = null
      this.loading = true

      try {
        const {data} = await axios.patch(`facebook/ad-accounts/${id}`, payload)

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.loading = false
      }
    },

    async bulkUpdateFacebookAdAccount(payload) {
      this.error = null
      this.loading = true

      try {
        const {data} = await axios.put(`facebook/ad-accounts/bulk-update`, payload)

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.loading = false
      }
    },
  },
})
